import React from "react";
import { appStrings } from "./strings";
import "./Footer.css";
import AppText from "./AppText";

const Footer: React.FC = () => {
    return (
        (!window.parent || window.parent === window.self) && (
            <footer>
                <a className="footer-logo" href={appStrings["footer-product-link"]} target="_blank">
                    <img
                        src={appStrings["footer-product-logo"]}
                        alt={appStrings["footer-product-name"]}
                    />
                </a>
                <div className="footer-small-print">
                    <span>
                        <AppText
                            textKey="footer-copyright-text"
                            values={{ year: new Date().getFullYear() }}
                        />
                    </span>
                    <ul className="footer-links">
                        <li>
                            <a href={appStrings["privacy-policy-link"]} target="_blank">
                                <AppText textKey="footer-privacy-policy-label" />
                            </a>
                        </li>
                        {/*<li>*/}
                        {/*    <a href=""><AppText textKey="footer-contact-us-label" /></a>*/}
                        {/*</li>*/}
                    </ul>
                </div>
            </footer>
        )
    );
};

export default Footer;
